import service from "@/store/services/properties-collections-service";
import Jsona from "jsona";
import properties from "../../i18n/fr/properties";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  registrationDivisions: {},
  propertiesCollection: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, propertiesCollection) => {
    state.propertiesCollection = propertiesCollection;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((propertiesCollection) => {
      commit("SET_RESOURCE", propertiesCollection);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((propertiesCollection) => {
      commit("SET_RESOURCE", propertiesCollection);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((propertiesCollection) => {
      commit("SET_RESOURCE", propertiesCollection);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
  importProperties({ commit, dispatch }, params) {
    return service.importProperties(params, this.$axios).then((response) => {
      return response;
    });
  },
  approve({ commit, dispatch }, params) {
    return service.approve(params, this.$axios);
  },
  printPdfLetters({ commit, dispatch }, data) {
    return service.printPdfLetters(data, this.$axios);
  },
  printSelectedPdfLetters({ commit, dispatch }, data) {
    return service.printSelectedPdfLetters(data, this.$axios);
  },
  setToPay({ commit, dispatch }, params) {
    return service.setToPay(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  propertiesCollection: (state) => state.propertiesCollection,
  registrationDivisions: (state) => state.registrationDivisions,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((propertiesCollection) => ({
      id: propertiesCollection.id,
      name: `${property.firstname} ${property.lastname}`,
    }));
  },
};

const propertiesCollections = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default propertiesCollections;
